/**
 * Имя UXFB-события каталога застройщиков. Должно побайтово совпадать с кампаниями в админке UXFB;
 * сценарии различаются атрибутом `action`, кампании таргетируются на него.
 */
export const UXFB_EVENT_DEVELOPER_CATALOG = 'developer_catalog';

/** Значение атрибута `action`: заход в каталог. */
export const UXFB_ACTION_OPEN = 'open';

/** Значение атрибута `action`: скролл каталога (просмотрено ≥ 10 застройщиков). */
export const UXFB_ACTION_SCROLL = 'scroll';

/** Количество застройщиков, после скролла которых уходит событие с `action: scroll` (в атрибуте `count` — строкой). */
export const UXFB_SCROLL_DEVELOPER_CATALOG_COUNT = 10;

/** По сценарию события каталога застройщиков отправляются только на десктопе. */
export const UXFB_PLATFORM = 'desktop';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
